module.exports = __webpack_public_path__ + "static/img/quiz-wrong-s.05ecd0e7.svg";